import { toStoreRows } from "@/utils/storeFinder";

export const mutations = {
  SET_FAQ: function (state, resData) {
    let result = [];

    for (let item of resData) {
      let obj = {};
      obj.id = item.id.toString();
      obj.title = item.question;
      obj.content = item.answer;

      switch (item.category_id) {
        case 1:
          obj.class = "개인정보";
          break;
        case 2:
          obj.class = "멤버십";
          break;
        case 3:
          obj.class = "상품";
          break;
        case 4:
          obj.class = "매장";
          break;
        case 5:
          obj.class = "일반";
          break;
      }

      obj.imgSrc = [];

      item.attachments.map((attc) => {
        obj.imgSrc.push(attc.download_url);
      });

      result.push(obj);
    }

    state.faqData = result;
  },

  SEARCH_FAQ: function (state, payload) {
    let boardData = payload[0];
    let searchText = payload[1];

    let result;
    result = boardData.filter((item) => {
      let filtered = true;
      filtered =
        item.title.includes(searchText) || item.content.includes(searchText);
      return filtered;
    });

    state.searchedData = result;
  },

  // 매장찾기와 같은 변환 규칙 사용 (영업 중 + 좌표 있는 매장, 매장코드·영업시간 포함)
  SET_STORE: function (state, resData) {
    state.storeData = toStoreRows(resData);
  },
};
